import { gql } from '@apollo/client'
import fragments from 'graphql/fragments'

// remote queries
export const GET_ESOP_SETUP = gql`
  query EsopSetup($baseProjectId: ID!) {
    esopSetup(baseProjectId: $baseProjectId) {
      ...EsopSetup
    }
  }
  ${fragments.esopSetup}
`

// ########## Remotes #############################

// remote mutations
export const ADD_ESOP_SETUP = gql`
  mutation AddEsopSetup($projectId: ID!, $input: EsopSetupInput!) {
    addEsopSetup(projectId: $projectId, esopSetupInput: $input) {
      ...EsopSetup
    }
  }
  ${fragments.esopSetup}
`

export const SAVE_ESOP_SETUP = gql`
  mutation SaveEsopSetup($esopSetupId: ID!, $input: EsopSetupInput!) {
    saveEsopSetup(esopSetupId: $esopSetupId, esopSetupInput: $input) {
      ...EsopSetup
    }
  }
  ${fragments.esopSetup}
`

export const DELETE_ESOP_SETUP = gql`
  mutation DeleteEsopSetup($esopSetupId: ID!) {
    deleteEsopSetup(esopSetupId: $esopSetupId) {
      ...EsopSetup
    }
  }
  ${fragments.esopSetup}
`

const esopSetupQueries = {
  getRemote: GET_ESOP_SETUP,
  addRemote: ADD_ESOP_SETUP,
  saveRemote: SAVE_ESOP_SETUP,
  deleteRemote: DELETE_ESOP_SETUP,
  saveOp: 'saveEsopSetup',
  addOp: 'addEsopSetup',
  deleteOp: 'deleteEsopSetup',
}

export default esopSetupQueries
